import { siteConfig } from "./siteConfig";

/**
 * Sends a quote-form submission to the site's own serverless lead endpoint
 * (see frontend/functions/api/lead.js), which creates the contact in
 * GoHighLevel via the standard API — no GHL embed, no premium webhook fee.
 *
 * @param {{ name: string, phone: string, message: string }} form
 * @returns {Promise<boolean>} true if the lead was accepted
 */
export async function submitLead(form) {
  const payload = {
    full_name: form.name,
    phone: form.phone,
    message: form.message,
    source: "Website Quote Form",
    page: typeof window !== "undefined" ? window.location.pathname : "",
  };

  const endpoint = siteConfig.leadEndpoint || "/api/lead";

  try {
    const res = await fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    if (!res.ok) console.error("[submitLead] Lead endpoint responded", res.status);
    return res.ok;
  } catch (err) {
    console.error("[submitLead] Failed to reach lead endpoint:", err);
    return false;
  }
}
